import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ILearnFromLeadersPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  description?: string;
  description_color?: string;
  desktop_background_color?: string;
  mobile_background_color?: string;
  /** Variant 1003 — optional full-bleed section background image */
  background_image?: string;
  background_image_alt?: string;
  /** Variant 1003 — lead CTA under the description; empty text hides it */
  cta_text?: string;
  cta_color?: string;
  cta_text_color?: string;
  status?: boolean;
  enable_animation?: boolean;
  metadata?: any[];
  profiles?: any[];
}

function isCreateSuccessStatus(status: number | undefined) {
  return status === 201 || status === 200;
}

export async function createLearnFromLeaders(payload: Partial<ILearnFromLeadersPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.LEARN_FROM_LEADERS.CREATE,
      payload
    );
    return isCreateSuccessStatus(response?.status) ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateLearnFromLeaders(
  id: number,
  payload: Partial<ILearnFromLeadersPayload>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.LEARN_FROM_LEADERS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function getLearnFromLeadersByComponentId(componentId: number) {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.LEARN_FROM_LEADERS.GET_BY_COMPONENT_ID(componentId)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
